/* eslint-disable import/no-cycle */
import axios from 'axios';
import _ from 'lodash';

import {
  CustomException,
  getIdToken,
  isResponseValid,
  roundToTwoDecimals,
  throwSAPError,
} from '../helpers/functions';
import i18n from '../helpers/i18nMain';
import {
  UPDATE_FAVOURITE,
  REMOVE_FAVOURITE_ITEM,
  CLEAR_FAVOURITE,
  SET_FAVOURITE_STATUS,
  LOAD_FAVOURITE_DATA,
  SET_ADD_REMOVE_FAVOURITE_STATUS,
} from '../helpers/types';

export const addToFavorite = (newItem, overrideQTY) => (dispatch, getState) => {
  const state = getState();
  const { favouriteItems } = state.favourite;
  let updatedfavoriteItems = [];
  const existedItem = _.find(favouriteItems, i => i.Material === newItem.Material);

  if (existedItem) {
    updatedfavoriteItems = favouriteItems.map(c => {
      const uc = c;
      if (uc.Material === newItem.Material) {
        if (overrideQTY) {
          uc.qty = newItem.qty;
        } else {
          uc.qty += newItem.qty;
        }
      }
      return uc;
    });
  } else {
    updatedfavoriteItems = favouriteItems;
    updatedfavoriteItems.push(newItem);
  }
  dispatch({
    type: UPDATE_FAVOURITE,
    payload: updatedfavoriteItems,
  });
};

export const removeFavouriteItem = m => ({ type: REMOVE_FAVOURITE_ITEM, payload: m });

export const clearFavorite = () => ({ type: CLEAR_FAVOURITE });

export const getFavouriteData = (enqueueSnackbar = () => {}, msg = '') => async (
  dispatch,
  getState
) => {
  try {
    const state = getState();
    const { auth } = state;

    const { client, systemIP, selectedSalesOrgData, BusinessPartner } = auth;
    const { SalesOrg, ItemProp, Plant, StorageLocation } = selectedSalesOrgData;
    dispatch({
      type: SET_FAVOURITE_STATUS,
      payload: { isLoading: true, failText: '' },
    });
    const idToken = await getIdToken(dispatch, getState);

    const MainService = axios.create({
      baseURL: `${systemIP}/`,
    });

    const favConfig = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
      },
      params: {
        $expand: 'to_Item',
        $filter: `SalesOrganization eq '${SalesOrg}'`,
      },
    };

    const toItemList = await MainService.get(
      `ZAE_PB2B_SRV/ZAE_I_ItemProposal(SalesDocument='${ItemProp}')`,
      favConfig
    ).catch(throwSAPError);
    const { to_Item } = toItemList.data.d;

    if (isResponseValid(toItemList)) {
      let data = to_Item.results;

      const stockQuantityRequestsConfig = {
        headers: {
          'AZURE-AUTH': `${idToken}`,
          'X-Requested-With': 'XMLHttpRequest',
        },
        params: {
          'sap-client': client,
        },
      };
      const stockPriceRequestsConfig = {
        headers: {
          'AZURE-AUTH': `${idToken}`,
          'X-Requested-With': 'XMLHttpRequest',
        },
        params: {
          'sap-client': client,
        },
      };

      const qtyItemsIn = data.map(r => ({
        Material: r.Material,
        Plant,
        StorageLoc: StorageLocation,
      }));
      const stockQuantityPayload = {
        N_PB2B_GET_AVL_QTY_INPUT: qtyItemsIn,
        N_PB2B_GET_AVL_QTY_OUTPUT: [],
      };
      const priceItemsIn = data.map((r, i) => {
        let Posnr = `${(i + 1) * 10}`;
        Posnr = Posnr.padStart(6, '0');
        return {
          Posnr,
          HighItem: '000000',
          Material: r.Material,
          Plant,
        };
      });

      const stockPricePayload = {
        N_PB2B_HEADER: [
          {
            Customer: BusinessPartner,
            SalesOrg,
          },
        ],
        N_PB2B_ITEMS_IN: priceItemsIn,
        N_PB2B_ITEMS_OUT: [],
      };
      const stockQuantityResponse = await MainService.post(
        'ZAE_FM_PB2B_GET_AVL_QTY_MULTI_SRV/PB2B_GET_AVL_QTY_INPUTSet',
        stockQuantityPayload,
        stockQuantityRequestsConfig
      ).catch(err => console.log(err));

      const stockPriceResponse = await MainService.post(
        'ZAE_FM_PB2B_SIMULATE_GET_PRICE_SRV/ZAE_FM_PB2B_SIMULATE_GET_PRICESet',
        stockPricePayload,
        stockPriceRequestsConfig
      ).catch(err => console.log(err));

      data = data.map(d => {
        let dF = d;
        try {
          const stockResults =
            stockQuantityResponse !== undefined
              ? stockQuantityResponse.data.d.N_PB2B_GET_AVL_QTY_OUTPUT.results
              : [];
          if (stockResults.length > 0) {
            const fD = stockResults.find(s => s.Material === dF.Material);
            dF = {
              ...dF,
              checked: false,
              ConditionQuantity: '1',
              ConditionQuantityUnit: 'EA',
              StockQuantity: roundToTwoDecimals(fD.AvlQty),
              StockQuantityUOM: fD.Uom,
            };
          } else {
            dF = {
              ...dF,
              checked: false,
              ConditionQuantity: '1',
              ConditionQuantityUnit: 'EA',
              StockQuantity: undefined,
              StockQuantityUOM: undefined,
            };
          }
          return dF;
        } catch (err) {
          return dF;
        }
      });
      data = data.map(d => {
        let dF = d;
        try {
          const priceResults = stockPriceResponse.data.d.N_PB2B_ITEMS_OUT.results;
          if (priceResults.length > 0) {
            const pD = priceResults.find(s => s.Material === dF.Material);
            dF = {
              ...dF,
              checked: false,
              ConditionQuantity: pD.ReqQty,
              ConditionQuantityUnit: pD.SalesUnit,
              SalesPrice: roundToTwoDecimals(pD.GrossPrice),
              SalesPriceUnit: pD.Currency, // TODO: Get Currency from Price FM
              Tax: pD.Tax,
            };
          } else {
            dF = {
              ...dF,
              checked: false,
              ConditionQuantity: '1',
              ConditionQuantityUnit: 'EA',
              SalesPrice: undefined,
              SalesPriceUnit: undefined,
              Tax: undefined,
            };
          }
          return dF;
        } catch (err) {
          return dF;
        }
      });

      const favData = to_Item.results.map(f => {
        const tD = data.find(d => d.Material === f.Material);
        return {
          ...f,
          ConditionQuantity: tD.ConditionQuantity,
          ConditionQuantityUnit: tD.ConditionQuantityUnit,
          SalesPrice: tD.SalesPrice,
          SalesPriceUnit: tD.SalesPriceUnit, // TODO: Get Currency from Price FM
          StockQuantity: tD.StockQuantity,
          StockQuantityUOM: tD.StockQuantityUOM,
          Tax: tD.Tax,
        };
      });

      dispatch({
        type: LOAD_FAVOURITE_DATA,
        payload: { list: favData },
      });
      dispatch({
        type: SET_ADD_REMOVE_FAVOURITE_STATUS,
        payload: false,
      });
      if (msg !== '') {
        enqueueSnackbar(
          msg === '1'
            ? i18n.t('favouriteScreenTranslations:ADDED_TO_FAVORITE')
            : i18n.t('favouriteScreenTranslations:REMOVED_FROM_FAVOURITE'),
          {
            variant: 'success',
          }
        );
      }
    } else {
      throw new CustomException(i18n.t('favouriteScreenTranslations:INVALID_RESPONSE'));
    }
  } catch (error) {
    enqueueSnackbar(i18n.t('favouriteScreenTranslations:ERROR_MSG'), {
      variant: 'error',
    });
    dispatch({
      type: SET_FAVOURITE_STATUS,
      payload: {
        isLoading: false,
        failText: i18n.t('favouriteScreenTranslations:ERROR_MSG'),
      },
    });
    dispatch({
      type: SET_ADD_REMOVE_FAVOURITE_STATUS,
      payload: false,
    });
  }
};

export const addRemoveFavourites = (
  data,
  enqueueSnackbar = () => {},
  updatedFavourite = () => {},
  Material = ''
) => async (dispatch, getState) => {
  try {
    const state = getState();
    const { auth } = state;
    const { systemIP } = auth;
    const idToken = await getIdToken(dispatch, getState);

    const config = {
      headers: {
        'AZURE-AUTH': `${idToken}`,
        'X-Requested-With': 'XMLHttpRequest',
      },
      params: {
        // 'sap-client': client,
      },
    };
    const MainService = axios.create({
      baseURL: `${systemIP}/`,
    });
    dispatch({
      type: SET_ADD_REMOVE_FAVOURITE_STATUS,
      payload: true,
    });
    const response = await MainService.post(
      'ZAE_PB2B_SRV/ZAE_FM_CB2B_ADD_DLT_ITEM_PROPSet',
      data,
      config
    ).catch(e => {
      let message = e.toString();
      if (e.response.data.error.message.value) {
        message = e.response.data.error.message.value;
      } else if (e.response.status && e.response.statusText) {
        message = `${e.response.status} - ${e.response.statusText}`;
      }
      enqueueSnackbar(message, {
        variant: 'error',
      });
    });

    if (isResponseValid(response)) {
      updatedFavourite(data.NavItems[0], Material, data.NavMain[0].AddDelete);
      // const msg = data.NavMain[0].AddDelete;

      // dispatch({
      //   type: SET_ADD_REMOVE_FAVOURITE_STATUS,
      //   payload: false,
      // });
    } else {
      throw new Error(i18n.t('favouriteScreenTranslations:INVALID_RESPONSE'));
    }
  } catch (error) {
    console.log(error);
    dispatch({
      type: SET_ADD_REMOVE_FAVOURITE_STATUS,
      payload: false,
    });
    enqueueSnackbar(i18n.t('favouriteScreenTranslations:SOMETHING_WENT_WRONG'), {
      variant: 'error',
    });
  }
};
